import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'

import { ButtonLink } from 'components/UI/ButtonLink/ButtonLink';

import { InputCheckList, typeInputCheckboxItem } from 'components/UI/InputCheckboxList/InputCheckList';
import { getStoreList } from 'model/dashboardStores/dStoresAPI';
import { IdStoresStateDataItem } from 'model/dashboardStores/dStoresReducer';
import { logoutSagaAC } from 'model/system/systemActionCreators';
import { Alert } from 'components/UI/Alert/Alert';
import { Loader } from 'components/UI/Loader/Loader';
import { ArrowLeftIcon } from '@heroicons/react/outline';



// Type
export type typeSelectStoresBlock = {
    variant?: string
    setOpenBlock: React.Dispatch<React.SetStateAction<boolean>>
    setSelectedStores: React.Dispatch<React.SetStateAction<string[]>>
    setOpenBlockSelectFile: React.Dispatch<React.SetStateAction<boolean>>
}

// Component
export const SelectStoresBlock : React.FC<typeSelectStoresBlock> = ({ variant, setOpenBlock,setOpenBlockSelectFile, setSelectedStores }) => {

    const dispatch = useDispatch()

    //  select store
    const [ stores, setStores ] = useState<typeInputCheckboxItem[]>([])
    const [ loader, setLoader ] = useState(false)
    const [validationObject,  setValidationObject]=useState({
        isSelectedStore: false
                                                            })

    // Did mount
    useEffect(() => {
        const setData = async () => {
            setLoader(true)
            let responseStores = await getStoreList({ filters: { name: null , deleted: false}, full: false })

            if (responseStores.status === 200) {
                const mappingData: typeInputCheckboxItem[] = responseStores.data.map((item: IdStoresStateDataItem) => ( {
                    id: item.id,
                    name: item.name,
                    label: item.name,
                    // value: item.address,
                    checked: false,
                    itemDeleted: item.deleted

                } ))
                setStores(mappingData)
            } else if (responseStores.status === 401) {
                dispatch(logoutSagaAC())
            }
            setLoader(false)
        }
        setData().then(() => setLoader(false))

        // eslint-disable-next-line
    }, [])


    const onSelectAllHandler = () => {
        const newStores = stores.map(item => ( { ...item, checked: true } ))
        setStores(newStores)
    }

    const onResetSelectedHandler = () => {
        const newStores = stores.map(item => ( { ...item, checked: false } ))
        setStores(newStores)
    }

    useEffect(()=>{
        if(stores.filter(item=>item.checked).length===0){
            setValidationObject((v)=>{return {...v, isSelectedStore: false}})
        } else {
            setValidationObject((v)=>{return {...v, isSelectedStore: true}})
        }
    }, [stores])

    const onSaveHandler= (e: React.FormEvent<HTMLFormElement> ) => {
        e.preventDefault()
       const checked = stores.filter(item=>item.checked).map(item=>item.id)
        setSelectedStores(checked)
        setOpenBlock(false)
        setOpenBlockSelectFile(true)
    }

    const onBackHandler = ()=>{
        onResetSelectedHandler()
        setOpenBlock(false)

    }

    return (

            <form onSubmit={ (e) => onSaveHandler(e) }
                  className={'flex flex-col gap-2 w-50vw'}
            >
                <div className={ 'mt-2' }>
                            <div className={ 'flex mb-2 justify-between items-end px-1 mt-4' }>
                                <h3 className={ 'font-medium text-gray-900' }><Trans>Select stores</Trans></h3>
                                <div className={ 'flex flex-wrap gap-4 text-sm font-medium' }>
                                    <ButtonLink type={ 'button' } label={ <Trans>Select all</Trans> }
                                                onClick={ onSelectAllHandler }/>
                                    <ButtonLink type={ 'button' } label={ <Trans>Reset selection</Trans> }
                                                onClick={ onResetSelectedHandler }/>
                                </div>
                            </div>
                            <div className={ 'flex flex-col gap-1' }>
                                <div>
                                    { stores.length > 0 ?
                                        <InputCheckList dataList={ stores }
                                                        setDataList={ setStores }
                                                        labelClassName={ 'break-all' }
                                                        fieldsetClassName={ 'grid grid-cols-3 gap-2  h-96 overflow-y-scroll' }/>
                                        : <Alert type={ 'info' } title={ <Trans>Have no data</Trans> }/>
                                    }
                                    { loader && <Loader/> }
                                </div>
                            </div>
                </div>

                <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                    <Button type="submit" disabled={ !validationObject.isSelectedStore } variant={ variant }
                            label={ <Trans>Select file</Trans> }/>
                    <Button type="button" secondary={ true } label={ <Trans>Back to previous step</Trans> }
                            onClick={ onBackHandler }
                            icon={<ArrowLeftIcon className={'w-4 h-4 text-gray-400 mr-3'} />}
                    />
                </div>

            </form>

    )
}
